import React from "react";
import ReactDOM from "react-dom";
import APlusDialog from "../shared/dialogs/APlusDialog";

const LitDevicesAPlusDialog = (props) => {
  const renderContent = () => <APlusDialog {...props} />;

  const container = document.querySelector(
    `#${props.containerId} .a-plus-dialog__container`
  );
  if (!container) {
    return null;
  }

  return ReactDOM.createPortal(renderContent(), container);
};

export default LitDevicesAPlusDialog;
